export default {
  currentFilter: null,
  init() {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    this.currentFilter = searchParams.get('filter[tag]');

    window.smr_eventbus.on('references_filter_changed', (filter) => {
      if (this.currentFilter === filter) return;

      if (filter === '*') {
        searchParams.delete('filter[tag]');
        this.currentFilter = null;
      } else {
        searchParams.set('filter[tag]', filter);
        this.currentFilter = filter;
      }

      if (this.currentFilter === null) {
        window.history.pushState({}, '', url.pathname);
      } else {
        window.history.pushState({}, '', `${url.pathname}?${searchParams}`);
      }

      // wait for fade out
      setTimeout(() => {
        window.smr_eventbus.emit('load_references', this.currentFilter);
      }, 200);
    });
  },
};
